// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-fields-wrapper {
  display: flex;
}
.mo-date-field {
  margin: 0 1px;
  min-width: 0;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
